import { setCheckButtons, setTableButtons } from '@/utils/getbuttons.js'
import { daysFormat } from '@/filters/index'
import { getSameAttribute } from '../handleData'
import { decimalDiv } from '@/utils/getCalculatedValue'
import { getDefaultBidUid } from '@/utils/defaultBid.js'

const percentByAmount = (done, contract) => {
  if (contract == null || Number(contract) === 0) return ''
  const ratio = decimalDiv(done || 0, contract)
  if (ratio == null || isNaN(Number(ratio))) return ''
  return (Number(ratio) * 100).toFixed(2)
}

const todayText = () => daysFormat(new Date())
const toDateText = (value) => {
  if (value === undefined || value === null || value === '') return ''
  const matched = String(value).match(/(\d{4}-\d{2}-\d{2})/)
  return matched ? matched[1] : ''
}
const parseLocalDate = (text) => {
  const parts = String(text || '').split('-')
  if (parts.length < 3) return new Date()
  return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]))
}
const getQueryOrgUid = (params) => {
  const queryValues =
    params &&
    params.state &&
    params.state.queryValues &&
    params.state.queryValues.imageProgress
  if (queryValues && queryValues.orgUid) return queryValues.orgUid
  return getDefaultBidOrgUid(params) || (params && params.orgValue) || ''
}
export function getDefaultBidOrgUid(params) {
  if (params && params.orgType === 'simPro') {
    return params.orgValue || ''
  }
  const bids =
    (params &&
      params.state &&
      params.state.bidSection &&
      params.state.bidSection.subBidSection) ||
    []
  const orgUid = (params && params.orgValue) || ''
  const markedUid = getDefaultBidUid(orgUid)
  const marked =
    markedUid &&
    bids.find((item) => {
      const uid = item && (item.orgUid || item.value)
      return uid && String(uid) === String(markedUid)
    })
  if (marked) return marked.orgUid || marked.value || ''
  const first = bids[0]
  return (first && (first.orgUid || first.value)) || ''
}
const normalizeQueryUid = (value) => {
  if (value === undefined || value === null || value === '') return ''
  if (Array.isArray(value)) {
    const last = value.filter((item) => item !== undefined && item !== null && item !== '')
      .pop()
    return last == null ? '' : String(last)
  }
  return String(value)
}
const codeTokenOf = (value) => {
  const text = String(value || '')
    .replace(/\u00a0/g, ' ')
    .trim()
  if (!text) return ''
  const token = text.split(/\s+/)[0]
  if (!token || token.length > 40) return ''
  if (!/^[A-Za-z0-9][A-Za-z0-9._-]*$/.test(token)) return ''
  if (
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
      token
    )
  ) {
    return ''
  }
  return token
}
const findTreeNode = (tree, uid) => {
  if (!uid || !Array.isArray(tree) || !tree.length) return null
  const keys = [
    'uid',
    'value',
    'subitemUid',
    'progressUid',
    'subitemCode',
    'progressItemCode',
    'codeName',
    'label'
  ]
  const walk = (list) => {
    for (let i = 0; i < (list || []).length; i++) {
      const item = list[i]
      if (!item) continue
      if (keys.some((key) => item[key] != null && String(item[key]) === uid)) {
        return item
      }
      if (codeTokenOf(item.subitemCode || item.label || item.codeName) === uid) {
        return item
      }
      const hit = walk(item.children)
      if (hit) return hit
    }
    return null
  }
  return walk(tree)
}
const findTreeNodeInTrees = (trees, uid) => {
  for (let i = 0; i < (trees || []).length; i++) {
    const hit = findTreeNode(trees[i], uid)
    if (hit) return hit
  }
  return null
}
const collectNodeUids = (node) => {
  const uids = []
  const walk = (current) => {
    if (!current) return
    const id = current.uid || current.value
    if (id) uids.push(String(id))
    if (current.subitemUid) uids.push(String(current.subitemUid))
    const kids = current.children || []
    kids.forEach(walk)
  }
  walk(node)
  return uids
}
const collectNodeCodes = (node) => {
  const codes = []
  const walk = (current) => {
    if (!current) return
    if (current.subitemCode) codes.push(String(current.subitemCode))
    if (current.progressItemCode && !current.subitemUid) {
      codes.push(String(current.progressItemCode))
    }
    const kids = current.children || []
    kids.forEach(walk)
  }
  walk(node)
  return codes
}
const collectTypeFilterUids = (node) => {
  const uids = []
  const walk = (current) => {
    if (!current || current.subitemUid) return
    const id = current.uid || current.value
    if (id) uids.push(String(id))
    const kids = current.children || []
    kids.forEach(walk)
  }
  walk(node)
  return uids
}
const collectTypeFilterCodes = (node) => {
  const codes = []
  const walk = (current) => {
    if (!current || current.subitemUid) return
    if (current.progressItemCode) codes.push(String(current.progressItemCode))
    const kids = current.children || []
    kids.forEach(walk)
  }
  walk(node)
  return codes
}
const rowMatchesAllow = (row, allow, codes, codePrefix) => {
  if (!row) return false
  const ids = [
    row.subitemUid,
    row.uid,
    row.value,
    row.progressUid,
    row.progressTypeUid,
    row.progressItemTypeUid
  ]
  if (ids.some((id) => id != null && allow[String(id)])) return true
  const rowCodes = [row.subitemCode, row.progressItemCode, codeTokenOf(row.codeName)]
  if (rowCodes.some((code) => code != null && codes[String(code)])) return true
  if (codePrefix) {
    const texts = [
      row.subitemCode,
      row.progressItemCode,
      row.codeName,
      row.label,
      codeTokenOf(row.subitemCode || row.codeName || row.label)
    ]
    if (
      texts.some((text) => {
        const value = String(text || '').replace(/\u00a0/g, ' ')
        return (
          value === codePrefix ||
          value.indexOf(codePrefix + '-') === 0 ||
          value.indexOf(codePrefix + ' ') === 0
        )
      })
    ) {
      return true
    }
  }
  return false
}
const walkFilterRows = (rows, keepRow) => {
  const out = []
  ;(rows || []).forEach((row) => {
    if (!row) return
    if (
      row.isSubitemGroup ||
      row.rowKind === 'subitem' ||
      row.rowKind === 'category'
    ) {
      if (keepRow(row)) {
        out.push(row)
        return
      }
      const children = walkFilterRows(row.children, keepRow)
      if (children.length) {
        out.push(Object.assign({}, row, { children }))
      }
      return
    }
    if (keepRow(row)) out.push(row)
  })
  return out
}
export function filterRowsBySubitemQuery(rows, subitemUid, ...trees) {
  const uid = normalizeQueryUid(subitemUid)
  if (!uid) return rows || []
  const node = findTreeNodeInTrees(trees, uid)
  const allow = { [uid]: true }
  const codes = {}
  let codePrefix = codeTokenOf(uid)
  if (node) {
    collectNodeUids(node).forEach((id) => {
      allow[id] = true
    })
    collectNodeCodes(node).forEach((code) => {
      codes[code] = true
    })
    codePrefix =
      (node.subitemCode && String(node.subitemCode)) ||
      codeTokenOf(node.label || node.codeName || node.subitemCN) ||
      codePrefix
  }
  return walkFilterRows(rows, (row) => rowMatchesAllow(row, allow, codes, codePrefix))
}
export function filterRowsByProgressTypeQuery(rows, typeUid, trees, typeCode) {
  const uid = normalizeQueryUid(typeUid)
  const extraCode = codeTokenOf(typeCode)
  if (!uid && !extraCode) return rows || []
  const treeList = Array.isArray(trees) ? trees : [trees]
  const node = uid ? findTreeNodeInTrees(treeList, uid) : findTreeNodeInTrees(treeList, extraCode)
  const allow = {}
  if (uid) allow[uid] = true
  const codes = {}
  if (extraCode) codes[extraCode] = true
  let codePrefix = extraCode
  if (node) {
    collectTypeFilterUids(node).forEach((id) => {
      allow[id] = true
    })
    collectTypeFilterCodes(node).forEach((code) => {
      codes[code] = true
    })
    if (node.progressItemCode) codePrefix = String(node.progressItemCode)
  }
  const keepRow = (row) => {
    if (!row) return false
    if (
      row.isSubitemGroup ||
      row.rowKind === 'subitem' ||
      row.rowKind === 'date' ||
      row.rowKind === 'list'
    ) {
      return false
    }
    const ids = [
      row.uid,
      row.value,
      row.progressUid,
      row.progressTypeUid,
      row.progressItemTypeUid
    ]
    if (ids.some((id) => id != null && allow[String(id)])) return true
    const code = row.progressItemCode
    if (code && codes[String(code)]) return true
    const nameCode = codeTokenOf(row.codeName || row.label)
    if (nameCode && codes[nameCode]) return true
    if (codePrefix && code) {
      const text = String(code)
      if (text === codePrefix || text.indexOf(codePrefix) === 0) return true
    }
    if (codePrefix && nameCode) {
      if (nameCode === codePrefix || nameCode.indexOf(codePrefix) === 0) {
        return true
      }
    }
    return false
  }
  return walkFilterRows(rows, keepRow)
}
export function filterProgressReportRows(rows, query, params) {
  const q = query || {}
  const fullTree =
    (params &&
      params.state &&
      params.state.division &&
      params.state.division.subitemList) ||
    []
  const boundTree =
    (params && params.getters && params.getters['division/progressSubitem']) ||
    []
  const viewFilter =
    (params &&
      params.state &&
      params.state.progress &&
      params.state.progress.viewFilter) ||
    {}
  const typeCode =
    q.progressTypeUid &&
    viewFilter.progressTypeUid &&
    String(q.progressTypeUid) === String(viewFilter.progressTypeUid)
      ? viewFilter.progressTypeCode || ''
      : ''
  const bySubitem = filterRowsBySubitemQuery(
    rows,
    q.subitemUid,
    fullTree,
    boundTree
  )
  return filterRowsByProgressTypeQuery(
    bySubitem,
    q.progressTypeUid,
    [
      (params &&
        params.getters &&
        params.getters['progress/progressCategoryTree']) ||
        [],
      (params &&
        params.getters &&
        params.getters['progress/boundProgressCategoryTree']) ||
        []
    ],
    typeCode
  )
}
export function mergeProgressTreeEdits(fullRows, editedRows) {
  const source = JSON.parse(JSON.stringify(fullRows || []))
  const map = {}
  const indexRows = (rows) => {
    const list = rows || []
    list.forEach((row) => {
      if (!row) return
      if (row.uid != null && row.uid !== '') {
        map[String(row.uid)] = row
      }
      if (row.children && row.children.length) indexRows(row.children)
    })
  }
  const applyEdits = (rows) => {
    const list = rows || []
    list.forEach((edited) => {
      if (!edited) return
      const target =
        edited.uid != null && edited.uid !== ''
          ? map[String(edited.uid)]
          : null
      if (target) {
        Object.keys(edited).forEach((key) => {
          if (key === 'children' || key === 'originValues') return
          target[key] = edited[key]
        })
      }
      if (edited.children && edited.children.length) applyEdits(edited.children)
    })
  }
  indexRows(source)
  applyEdits(editedRows)
  return source
}
const progressSubitemQueryField = {
  key: 'subitemUid',
  label: '分部分项',
  labelWidth: '76px',
  type: 'cascader',
  wide: true,
  options: (params) => {
    return params.getters['division/progressSubitem']
  },
  placeholder: '请选择分部分项',
  filterable: true,
  checkStrictly: true,
  showAllLevels: false,
  checkByValue: true,
  emitPath: false,
  span: 8
}
const progressTypeQueryField = {
  key: 'progressTypeUid',
  label: '形象进度类别',
  labelWidth: '108px',
  type: 'cascader',
  wide: true,
  options: (params) => {
    return params.getters['progress/boundProgressCategoryTree']
  },
  placeholder: '请选择形象进度类别',
  filterable: true,
  checkStrictly: true,
  showAllLevels: false,
  checkByValue: true,
  emitPath: false,
  span: 8
}
const viewProgressTypeQueryField = Object.assign({}, progressTypeQueryField, {
  options: (params) => {
    return (
      (params.getters && params.getters['progress/progressCategoryTree']) ||
      (params.getters &&
        params.getters['progress/boundProgressCategoryTree']) ||
      []
    )
  }
})
export function getBidCreateDate(params) {
  const orgUid = getQueryOrgUid(params)
  const bids =
    (params &&
      params.state &&
      params.state.bidSection &&
      params.state.bidSection.subBidSection) ||
    []
  const bid = bids.find(
    (item) => item && String(item.orgUid || item.value) === String(orgUid)
  )
  if (!bid) return ''
  return (
    toDateText(bid.createTime) ||
    toDateText(bid.create_time) ||
    toDateText(bid.orgBeginTime) ||
    toDateText(bid.org_begin_time) ||
    toDateText(bid.planStartDate) ||
    toDateText(bid.plan_start_date)
  )
}
export function buildPeriodShortcuts(params) {
  const today = todayText()
  const now = new Date()
  const createDate = getBidCreateDate(params) || today
  return [
    { text: '当日', type: 'today', range: [today, today] },
    {
      text: '当月',
      type: 'month',
      range: [daysFormat(new Date(now.getFullYear(), now.getMonth(), 1)), today]
    },
    {
      text: '当年',
      type: 'year',
      range: [daysFormat(new Date(now.getFullYear(), 0, 1)), today]
    },
    { text: '累计', type: 'total', range: [createDate, today] }
  ]
}
const periodPickerOptions = (params) => {
  return {
    shortcuts: buildPeriodShortcuts(params).map((item) => {
      return {
        text: item.text,
        onClick(picker) {
          picker.$emit('pick', [
            parseLocalDate(item.range[0]),
            parseLocalDate(item.range[1])
          ])
        }
      }
    })
  }
}
const noFuturePickerOptions = {
  disabledDate(time) {
    return time.getTime() > Date.now()
  }
}
const reportRateMax = (row) => {
  if (row && row.rateMax != null) return row.rateMax
  return 100
}
const reportInputForm = (type, extra) => {
  return () => {
    return (row) => {
      if (!row || row.isSubitemGroup || !row.residueQuantity) return null
      const cfg = Object.assign({ type: type }, extra || {})
      if (type === 'rateSlider') cfg.max = reportRateMax(row)
      return cfg
    }
  }
}
const editInputForm = (type, extra) => {
  return () => {
    return (row) => {
      if (
        !row ||
        row.isSubitemGroup ||
        row.isCategory ||
        row.rowKind === 'category' ||
        row.rowKind === 'subitem'
      ) {
        return null
      }
      const cfg = Object.assign({ type: type }, extra || {})
      if (type === 'rateSlider') cfg.max = reportRateMax(row)
      return cfg
    }
  }
}
const viewInputForm = () => {
  return () => null
}
const progressTableColumns = (mode) => {
  const form =
    mode === 'report'
      ? reportInputForm
      : mode === 'edit'
      ? editInputForm
      : viewInputForm
  const columns = [
    {
      prop: 'codeName',
      label:
        mode === 'report'
          ? '分项工程 / 形象进度 / 清单细目'
          : '分项工程 / 形象进度分类 / 完成日期 / 清单细目',
      minWidth: '360px',
      align: 'left',
      className: 'wrap-cell',
      overflow: false,
      overflowWidth: true
    },
    { prop: 'unit', width: '100px', label: '单位' },
    {
      prop: 'designQuantity',
      label: '设计工程量'
    }
  ]
  if (mode !== 'view') {
    columns.push({
      prop: 'doneQuantity',
      label: '累计完成量'
    })
    columns.push({
      prop: 'residueQuantity',
      label: '剩余工程量'
    })
    columns.push({
      prop: 'doneRate',
      label: '填报完成比例(%)',
      formItem: form('rateSlider'),
      number: true,
      width: '126px',
      minWidth: '126px',
      keepWidth: true,
      overflow: false,
      className: 'rate-slider-cell'
    })
  }
  columns.push({
    prop: 'completedQuantities',
    label: mode === 'view' ? '填报完成量' : '*填报完成量',
    formItem: form('input'),
    number: true
  })
  if (mode === 'view') {
    columns.push({
      prop: 'residueQuantity',
      label: '剩余工程量'
    })
  }
  columns.push(
    {
      prop: 'uploadDate',
      label: mode === 'view' ? '完成日期' : '*完成日期',
      formItem: form('time', {
        pickerOptions: noFuturePickerOptions
      })
    },
    {
      prop: 'remark',
      label: '备注',
      formItem: form('input')
    }
  )
  if (mode === 'edit') {
    columns.push({
      label: '操作',
      width: '100px',
      buttons: () => {
        return (row) => {
          if (!row || (row.rowKind !== 'date' && row.rowKind !== 'list')) {
            return []
          }
          return setTableButtons(['删除'])
        }
      }
    })
  }
  return columns
}
const progress = {
  pageTabs: [
    {
      label: '进度统计',
      theme: 'progress',
      step: 'imageProgressList',
      stepLabel: '进度统计列表',
      checkFun: 'progress/getProgressItems'
    } /* ,
    {
      label: '进度计划',
      theme: 'progress',
      step: 'progressPlanList',
      stepLabel: '进度计划列表',
      checkFun: 'division/getProgressPlan'
    }*/
  ],
  imageProgress: {
    name: 'imageProgress',
    componentTypes: [
      'navigate',
      'pageTabs',
      'check',
      'tables',
      'dialogForm'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    getListFun: 'progress/getProgressItems',
    editFun: 'progress/editProgressItem',
    deleteFun: 'progress/deleteProgressItem',
    headButtons: (params) => {
      return params.orgType === 'simPro'
        ? setCheckButtons([
            { name: '进度填报', icon: 'el-icon-plus' },
            { name: '编辑填报', type: 'primary', plain: true }
          ])
        : []
    },
    tagInfo:
      '个人登录编辑时，仅可改自己创建的各分项当前最后一次填报；更早历史请用机构账号。点击列表可查看当前周期该行对应分项和形象进度类型的原始填报，改查询条件可看全部。',
    compactQuery: true,
    detailPage: [
      {
        buttonName: '进度填报',
        type: 'dialogForm',
        name: 'selectReportSubitem',
        theme: 'imageProgress',
        pageStatus: 'add'
      },
      {
        buttonName: '编辑填报',
        type: 'tables',
        name: 'editProgress',
        theme: 'progress',
        step: 'editProgressList',
        label: '编辑填报',
        expandAll: true,
        checkFun: 'progress/reloadEditProgress'
      },
      {
        codes: ['currentDoneQuantity', 'currentDoneRate', 'currentDoneAmount'],
        type: 'tables',
        name: 'viewProgress',
        theme: 'progress',
        step: 'viewProgressList',
        label: '进度填报数据',
        expandAll: true,
        checkFun: 'progress/reloadEditProgress'
      }
    ],
    queryParams: {
      orgUid: (params) => {
        return getDefaultBidOrgUid(params)
      },
      subitemUid: '',
      subitemLevel: '',
      periodType: 'today',
      period: () => {
        const today = daysFormat(new Date())
        return [today, today]
      }
    },
    selectData: [
      {
        key: 'period',
        label: '统计周期',
        labelWidth: '90px',
        type: 'time',
        timetype: 'daterange',
        clearable: false,
        unlinkPanels: true,
        pickerOptions: periodPickerOptions,
        periodShortcuts: buildPeriodShortcuts,
        startPlaceholder: '开始',
        endPlaceholder: '结束',
        span: 10
      },
      {
        key: 'orgUid',
        label: '项目标段',
        labelWidth: '90px',
        type: 'select',
        options: (params) => {
          return params.state.bidSection.subBidSection
        },
        checkByValue: true,
        clearable: false,
        filterable: true,
        placeholder: '请选择项目标段',
        span: 5
      },
      {
        key: 'subitemUid',
        label: '分部分项',
        labelWidth: '76px',
        type: 'cascader',
        wide: true,
        options: (params) => {
          return params.getters['division/progressSubitem']
        },
        placeholder: '请选择分部分项',
        filterable: true,
        checkStrictly: true,
        showAllLevels: false,
        checkByValue: true,
        emitPath: false,
        span: 8
      }
    ],
    outListHeight: 180,
    expandAll: true,
    showSummary: true,
    summaryMethod: () => {
      return (param) => {
        const columns = (param && param.columns) || []
        const data = (param && param.data) || []
        if (!columns.length) return []
        const currentDoneAmount = getSameAttribute(data, 'currentDoneAmount')
          .addValue
        const listDesignAmount = getSameAttribute(data, 'listDesignAmount')
          .addValue
        return columns.map((column, index) => {
          const prop = column && column.property
          if (index === 0 || prop === 'codeName') {
            return '所有工程类型合计'
          }
          if (prop === 'currentDoneAmount') return currentDoneAmount
          if (prop === 'currentDoneRate') {
            return percentByAmount(currentDoneAmount, listDesignAmount)
          }
          return ''
        })
      }
    },
    rowData: (params) => {
      return params.getters['progress/progressTree']
    },
    columns: () => {
      var columns = [
        {
          prop: 'codeName',
          label: '进度分项类型/分部分项名称',
          align: 'left',
          width: '480px',
          className: 'wrap-cell',
          overflowWidth: 80
        },
        { prop: 'unit', label: '单位' },
        { prop: 'imageQuantity', label: '形象工程量' },
        {
          prop: 'currentDoneQuantity',
          label: '完成工程量',
          drillDown: true,
          tooltip: () => {
            return () => {
              return { tipValue: '点击查看该层级进度填报数据' }
            }
          }
        },
        {
          prop: 'currentDoneRate',
          label: '完成百分比(%)',
          drillDown: true,
          tooltip: () => {
            return () => {
              return { tipValue: '点击查看该层级进度填报数据' }
            }
          }
        },
        {
          prop: 'currentDoneAmount',
          label: '完成清单额(元)',
          drillDown: true,
          tooltip: () => {
            return () => {
              return { tipValue: '点击查看该层级进度填报数据' }
            }
          }
        }
      ]
      return columns
    },
    selectReportSubitem: {
      name: 'selectReportSubitem',
      title: '选择分项工程',
      width: '560px',
      addFun: 'progress/prepareReportBySubitems',
      formParams: {
        subitemUids: []
      },
      formRules: {
        subitemUids: [
          {
            required: true,
            type: 'array',
            message: '请选择分项工程',
            trigger: 'change'
          }
        ]
      },
      formData: [
        {
          key: 'subitemUids',
          label: '分部分项',
          type: 'cascader',
          options: (params) => {
            return params.getters['division/progressSubitem']
          },
          multiple: true,
          checkStrictly: true,
          checkByValue: true,
          emitPath: false,
          filterable: true,
          clearable: true,
          collapseTags: true,
          showAllLevels: true,
          expandTrigger: 'hover',
          placeholder: '按层级选择，勾选上级将包含其下全部分项',
          tips:
            '勾选要填报进度的工程名称，勾选父级默认全选下级所有分项工程，确定后进入填报页，系统会自动为你过滤掉完成量100%无需填报的分项。',
          span: 24
        }
      ]
    }
  },
  reportProgress: {
    name: 'reportProgress',
    componentTypes: ['navigate', 'check', 'tables'],
    headButtons: setCheckButtons([
      { name: '提交', code: 'submitProgress', type: 'primary' },
      { name: '重置', code: 'resetProgress', type: '', plain: true }
    ]),
    headButtonsTop: true,
    compactQuery: true,
    saveFun: 'progress/reportProgress',
    getParentFun: 'progress/getProgressItems',
    queryFun: 'progress/noopProgressQuery',
    queryParams: (params) => {
      const list =
        (params.state &&
          params.state.queryValues &&
          params.state.queryValues.imageProgress) ||
        {}
      return { subitemUid: list.subitemUid || '', progressTypeUid: '' }
    },
    selectData: [progressSubitemQueryField, progressTypeQueryField],
    expandAll: true,
    tagInfo:
      '请先录入形象进度数据，系统会自动按照占剩余工程量的比例计算对应清单完成量，但修改清单量，不联动形象进度；完成日期默认填入当日，可修改，但不能选未来时间。',
    rowData: (params) => {
      const query =
        (params.state.queryValues && params.state.queryValues.reportProgress) ||
        {}
      return filterProgressReportRows(
        params.state.progress.subitemProgressInfo,
        query,
        params
      )
    },
    columns: progressTableColumns('report')
  },
  editProgress: {
    name: 'editProgress',
    componentTypes: ['navigate', 'check', 'tables'],
    headButtons: setCheckButtons([
      { name: '提交', code: 'submitProgress', type: 'primary' },
      { name: '重置', code: 'resetProgress', type: '', plain: true }
    ]),
    headButtonsTop: true,
    compactQuery: true,
    saveFun: 'progress/saveEditProgress',
    getListFun: 'progress/reloadEditProgress',
    getParentFun: 'progress/getProgressItems',
    queryFun: 'progress/noopProgressQuery',
    queryParams: (params) => {
      const list =
        (params.state &&
          params.state.queryValues &&
          params.state.queryValues.imageProgress) ||
        {}
      return { subitemUid: list.subitemUid || '', progressTypeUid: '' }
    },
    selectData: [progressSubitemQueryField, progressTypeQueryField],
    expandAll: true,
    deleteFun: () => {
      return (row) => {
        if (row && row.rowKind === 'list') return 'progress/deleteListCompletion'
        return 'progress/deleteProgressUpload'
      }
    },
    deleteConfirm: (params) => {
      if (params.row && params.row.rowKind === 'date') {
        return '删除该日期的形象进度填报将同时删除关联清单完成数据，是否继续?'
      }
      return '此操作将永久删除该条清单完成数据, 是否继续?'
    },
    tagInfo: (params) => {
      const deleteTip =
        '删除形象进度会联动删除其下清单数据，删除清单数据不影响形象进度。'
      if (params.state && params.state.user && params.state.user.userType === 'per') {
        return (
          '当前用户为个人用户登录，仅可编辑各分项由用户自己创建的且为分项下最后一次填报的数据，如需修改更早时间的历史数据，请使用机构用户账号登录修改。' +
          deleteTip
        )
      }
      return '当前用户为机构用户登录，可修改各分项全部日期的填报数据。' + deleteTip
    },
    rowData: (params) => {
      const query =
        (params.state.queryValues && params.state.queryValues.editProgress) ||
        {}
      return filterProgressReportRows(
        params.state.progress.editProgress,
        query,
        params
      )
    },
    columns: progressTableColumns('edit')
  },
  viewProgress: {
    name: 'viewProgress',
    componentTypes: ['navigate', 'check', 'tables'],
    headButtonsTop: true,
    compactQuery: true,
    getListFun: 'progress/reloadEditProgress',
    getParentFun: 'progress/getProgressItems',
    queryFun: 'progress/noopProgressQuery',
    queryParams: (params) => {
      const viewFilter =
        (params.state &&
          params.state.progress &&
          params.state.progress.viewFilter) ||
        {}
      return {
        subitemUid: viewFilter.subitemUid || '',
        progressTypeUid: viewFilter.progressTypeUid || ''
      }
    },
    selectData: [progressSubitemQueryField, viewProgressTypeQueryField],
    expandAll: true,
    tagInfo:
      '列表按填报日期展示当前统计范围内的原始填报数据。进入时按点击行的分部分项和形象进度类型筛选；清除条件可查看全部；重置恢复进入时的筛选。',
    rowData: (params) => {
      const query =
        (params.state.queryValues && params.state.queryValues.viewProgress) ||
        {}
      return filterProgressReportRows(
        params.state.progress.editProgress,
        query,
        params
      )
    },
    columns: progressTableColumns('view')
  },
  progressPlan: {}
}

export default progress
